import { render, staticRenderFns } from "./Reminders.vue?vue&type=template&id=7fb09aa5&scoped=true"
import script from "./Reminders.vue?vue&type=script&lang=js"
export * from "./Reminders.vue?vue&type=script&lang=js"
import style0 from "./Reminders.vue?vue&type=style&index=0&id=7fb09aa5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb09aa5",
  null
  
)

export default component.exports